import { FDBodyText, FDIcon, FDTooltip } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

export const TextWithTooltip = ({ value, resource }) => {
  const icon = resource.attr('tooltipIcon');
  const tooltipText = resource.attr('tooltipText');

  if (icon && tooltipText) {
    return (
      <FDBodyText value={<>{value}<FDTooltip title={tooltipText}><FDIcon size={'sm'} icon={icon} /></FDTooltip></>} />
    );
  }
  return <FDBodyText value={value} />;
};

TextWithTooltip.propTypes = {
  value: PropTypes.string.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
